<template>
  <Container class="my-16 lg:my-24">
    <form
      class="bg-gradient-black-01 relative rounded-3xl p-6 text-right text-white lg:p-8"
      @submit.prevent="submitForm">
      <h2 class="text-left text-4xl text-white">
        {{ title }}
      </h2>
      <p
        v-if="copy && copy.length > 0"
        class="my-6 text-left">
        {{ copy }}
      </p>
      <div class="mb-6 grid grid-cols-1 gap-6 text-left md:grid-cols-2">
        <SectionEmailFormInput
          id="first-name"
          v-model="inputs.firstName"
          :state="state"
          label="First Name"
          input-type="text"
          :required="true" />
        <SectionEmailFormInput
          id="last-name"
          v-model="inputs.lastName"
          :state="state"
          label="Last Name"
          input-type="text"
          :required="true" />
        <SectionEmailFormInput
          id="email"
          v-model="inputs.email"
          :state="state"
          label="E-mail"
          input-type="email"
          :required="true" />
        <SectionEmailFormInput
          id="company"
          v-model="inputs.company"
          :state="state"
          label="Company"
          input-type="text"
          :required="false" />
      </div>
      <div class="text-left">
        <label
          for="message"
          class="required"
          >Message</label
        >
        <textarea
          id="message"
          v-model="inputs.message"
          required
          :disabled="state === 'loading'"
          name="message"
          class="w-full rounded-2xl border-none bg-gray-300 px-6 py-4 text-base font-medium text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-black disabled:cursor-wait"
          placeholder="Message"
          :class="state === 'error' ? 'ring ring-red-200' : 'ring-0'" />
      </div>
      <div
        class="contact-terms flex justify-end space-x-4 py-6 text-sm font-medium text-gray-200 transition-opacity duration-100"
        v-html="privacyLabel" />
      <SectionEmailFormButton
        :state="state"
        :label="buttonLabel" />
      <SectionEmailFormToast
        :state="state"
        :success-message="successMessage"
        :error-message="errorMessage" />
    </form>
  </Container>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  import type { FormStateType } from '../../../models/form'

  type EmailFormProps = {
    title: string
    emailTo: string
    emailSubject: string
    copy: string
    privacyLabel: string
    buttonLabel: string
    successMessage: string
    errorMessage: string
  }

  const props = defineProps<EmailFormProps>()

  const inputs = ref({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    message: ''
  })

  const state = ref<FormStateType>('idle')

  async function submitForm(event: Event) {
    event.preventDefault()

    state.value = 'loading'

    const formData = {
      to: props.emailTo,
      subject: props.emailSubject,
      firstName: inputs.value.firstName,
      lastName: inputs.value.lastName,
      email: inputs.value.email,
      company: inputs.value.company,
      message: inputs.value.message
    }

    await fetch('https://outfit7.com/send-transac-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(async response => {
        if (response.ok) {
          state.value = 'success'
          inputs.value.firstName = ''
          inputs.value.lastName = ''
          inputs.value.email = ''
          inputs.value.company = ''
          inputs.value.message = ''
        } else {
          throw new Error(await response.json())
        }
      })
      .catch(error => {
        state.value = 'error'
        console.error(error)
      })
      .finally(() => {
        setTimeout(() => {
          state.value = 'idle'
        }, 3000)
      })
  }
</script>

<style scoped lang="scss">
  .required::after {
    content: ' *';
  }

  .contact-terms:deep(a) {
    @apply font-bold underline;
  }
</style>
